import Vue from "vue";
import Photographer from "../../components/Photographer";
import Slick from "vue-slick";

let els;

if ((els = document.querySelectorAll(".studios-list")).length > 0) {
  for (let i = 0; i < els.length; i++) {
    const el = els[i];

    new Vue({
      el: el,
      name: "StudioList",
      components: { Slick, Photographer },
      data() {
        return {
          cities: [],
          citiesSelect: [],
          opened: false,
          openModal: false,
          displayModal: "none",
          currentStudio: false,
          currentLocation: false,
          studios: window.passdata.studios,
          slickOptions: {
            arrows: false,
            dots: false,
            infinite: true,
            slidesToShow: 1,
          },
        };
      },
      computed: {
        studiosList: function () {
          if (this.currentLocation) {
            let listOfStudios = [];
            this.studios.forEach((studio) => {
              studio.distance = this.getDistance(
                studio.coor[0],
                this.currentLocation
              );
              listOfStudios.push(studio);
            });

            listOfStudios.sort((a, b) => {
              return a.distance > b.distance ? 1 : -1;
            });
            return listOfStudios;
          } else {
            return this.studios;
          }
        },
      },
      methods: {
        getImage: window.getImage,
        saveData(mycity, mystudio) {
          localStorage.setItem("booking-selected-city", mycity.toLowerCase());
          localStorage.setItem("booking-selected-studio", mystudio);
          document.location.href =
            document.location.origin + "/reserver-ma-seance";
        },
        reviews(studio) {
          this.currentStudio = studio;
          this.openModal = true;
          this.displayModal = "block";
        },
        slickNext(index) {
          this.$refs.slick[index].next();
        },
        slickPrev(index) {
          this.$refs.slick[index].prev();
        },
        slickNextMobile(index) {
          this.$refs.slickMobile[index].next();
        },
        slickPrevMobile(index) {
          this.$refs.slickMobile[index].prev();
        },
        closeModal() {
          this.openModal = false;
          this.displayModal = "none";
        },
        getDistance(coords1, coords2) {
          var point1 = new google.maps.LatLng(coords1.lat, coords1.lng);
          var point2 = new google.maps.LatLng(coords2.lat, coords2.lng);

          var distance = google.maps.geometry.spherical.computeDistanceBetween(
            point1,
            point2
          );
          return distance / 1000;
        },
        getDistance2(coords1, coords2) {
          const radLat1 = (Math.PI * coords1.lat) / 180;
          const radLat2 = (Math.PI * coords2.lat) / 180;
          const theta = coords1.lng - coords2.lng;
          const radTheta = (Math.PI * theta) / 180;

          let dist =
            Math.sin(radLat1) * Math.sin(radLat2) +
            Math.cos(radLat1) * Math.cos(radLat2) * Math.cos(radTheta);

          if (dist > 1) dist = 1;

          dist = Math.acos(dist);
          dist = (dist * 180) / Math.PI;
          dist = dist * 60 * 1.1515;

          return dist;
        },
      },
      created() {
        const success = (position) => {
          // this.currentLocation = {
          //     "lat": 48.8293647,
          //     "lng": 2.3638148
          // };

          // this.currentLocation = {
          //     "lat": 48.863701,
          //     "lng": 2.361090
          // };

          this.currentLocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };

          // this.findNearest(this.currentLocation);

          // Do something with the position
        };

        const error = (err) => {
          console.log("Permission denied");
          this.currentLocation = false;
        };

        // This will open permission popup
        navigator.geolocation.getCurrentPosition(success, error);
      },
    });
  }
}
